module.exports = __webpack_public_path__ + "static/img/epidemic-3.8f9f369.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/epidemic-3.png
// module id = T2kE
// module chunks = 1